import * as React from 'react';
import { cloneDeep, isEqual } from 'lodash';
import { Radio } from 'antd';
import {
  DataQuery,
  Attribute,
  InputParameter,
  InputParameterType,
  FunctionParameter,
  ReferenceNode,
  ParameterType,
  Reference,
  FrameItem,
  ParameterConfig
} from '@interface/index';
import {
  NiTable,
  ReferenceTextArea
} from '@component/index';
import {
  NiCommonCascader,
  SELECTION_KEY,
  SelectionOption,
  SpecialValueType,
  renderSelectionVariable
} from '@config/index';
import { ParameterMapStore, attributeToParameter } from '@lib/index';

const RadioGroup = Radio.Group;

type InputPrameterCompProps = {
  style?: React.CSSProperties;
  frame: FrameItem;
  disabled?: boolean;
  function: Reference;
  slots: ParameterConfig[];
  data: InputParameter[];
  onChange: (next: InputParameter[]) => void;
};

export const InputParameterComp = (props: InputPrameterCompProps) => {

  const [data, setData] = React.useState<InputParameter[]>([]);
  const [paramDefs, setParamDefs] = React.useState<FunctionParameter[]>([]);

  React.useEffect(() => {

    const lastNode = props.function && props.function.length &&
      props.function[props.function.length - 1];

    const dataQuery = lastNode && ParameterMapStore.get(lastNode.id);
    const paramDefsT = dataQuery && dataQuery.parameters || [];

    setParamDefs(paramDefsT);

    const nextData = cloneDeep(props.data || []);

    if (nextData.length !== paramDefsT.length) {
      paramDefsT.forEach((p: FunctionParameter, index: number) => {
        if (index > nextData.length - 1) {
          nextData.push({
            type: InputParameterType.Variable,
            variable: [],
            constant: ''
          });
        }
      });

      onChange(nextData.slice(0, paramDefsT.length));
    }

    setData(nextData.slice(0, paramDefsT.length));
  }, [props.function, props.data]);

  function onChange(next: InputParameter[]) {
    const ret = next.slice(0, paramDefs.length);
    setData(ret);
    props.onChange(ret);
  }

  return <NiTable
    style={props.style}
    dataSource={data}
    rowKey={(record: InputParameter, index?: number) => `${index}`}
    pagination={false}
    columns={[
      {
        title: 'Name',
        dataIndex: '',
        render: (_: string, record: InputParameter, index: number) => {
          return paramDefs[index].name;
        }
      },
      {
        title: 'Type',
        dataIndex: 'type',
        render: (type: string, record: InputParameter, index: number) => {
          return <RadioGroup
            disabled={props.disabled}
            style={{ paddingTop: 0 }}
            value={type}
            onChange={(e: any) => {
              data[index].type = e.target.value;
              onChange(data);
            }}
          >
            <Radio key="variable" value="variable">
              Variable
            </Radio>
            <Radio key="constant" value="constant">
              Constant
            </Radio>
          </RadioGroup>;
        }
      },
      {
        title: 'value',
        dataIndex: '',
        render: (_: any, record: InputParameter, index: number) => {
          return record.type === InputParameterType.Variable
            ? <NiCommonCascader
              key="variable"
              disabled={props.disabled}
              selectionkey={SELECTION_KEY.AVAILABLE_FUNCTION_PARAMETER}
              rootpath={[{
                value: props.frame.id || '',
                value_type: props.frame.type || ''
              }]}
              value={record.variable}
              displayRender={(label: string[], selectedOptions?: SelectionOption[]) => {
                const item = record.variable;
                return renderSelectionVariable(item);
              }}
              onChange={(value: string[], selectedOptions?: SelectionOption[]) => {

                const target = cloneDeep(record.variable);
                const variable: ReferenceNode[] = [];

                (selectedOptions || []).forEach((opt: SelectionOption) => {
                  if (opt.valueType === SpecialValueType.Index) {
                    const v = variable[variable.length - 1];
                    v.showIndex = true;
                    v.index = opt.index;

                  } else {
                    variable.push({
                      id: opt.value as string,
                      name: opt.label as string || '',
                      type: opt.valueType as ParameterType
                    });
                  }
                });

                if (isEqual(variable, target)) {
                  return;
                }

                data[index].variable = variable;
                onChange(data);
              }}
            />
            : <ReferenceTextArea
              parameterMap={ParameterMapStore.all()}
              initParameters={props.slots}
              allowNewLine={false}
              disabled={props.disabled}
              className="reset"
              data={record.constant}
              update={(next: string) => {
                data[index].constant = next;
                onChange(data);
              }}
            />;
        }
      }
    ]}
  />;
};
